<template>
  <div class="deviceAce page-padding">
    <router-view></router-view>
  </div>
</template>
<script>
export default {}
</script>
<style scoped>
.deviceAce {
    width: 100%;
    height: 100%;
}
</style>